import { Transaction } from "../../../core/models/transaction";
import { HandlingUnitDetailDTO } from "./handling-unit-detail";

export interface HandlingUnitMasterDTO {
    id?: number;
    isActive?: boolean;
    updatedDate?: Date;
    createdDate?: Date;
    createdBy?: string;
    createdByUserId?: number;
    barcode?: string;
    roomLocationId?: number;
    roomLocationName?: string;
    roomId?: number;
    roomName?: string;
    warehouseId?: number;
    warehouseName?: string;
    inventoryStatusId?: number;
    inventoryStatusName?: string;
    inventoryStatusIsLocked?: boolean;
    inventoryStatusIsWarning?: boolean;
    handlingUnitDetails?: HandlingUnitDetailDTO[];
    transactions?: Transaction[];
    transactionReasonCodeId?: number;
    orderNumber?: string;
    orderId?: number;
    weight?: number;

    batchId?: number;
    inventoryBatchCreationTime_Seconds?: number;

    workOrders?: HandlingUnitWorkOrderSummaryDTO[];
    //front end//
    parentLotNumber?: string;
    integrationId?: string;
    boxStart?: string;
    boxEnd?: string;
    dateIn?: Date;
    dateOut?: Date;
    purchaseOrderERPId?: string;

    //For UI purpose only
    purchaseOrderId?: number;
    vendorId?: number
    varietyId?: number
    cropYearId?: number
}


export interface HandlingUnitWorkOrderSummaryDTO {
    workOrderId?: number;
    workOrderTypeId?: number;
    workOrderType?: string;
    workOrderTypeColor?: string;
    scheduledStartDate?: string;
    scheduledEndDate?: string;
    startDate?: string;
    endDate?: string;
    scheduledUserName?: string;
    comments?: string;
    workOrderStatusId?: number;
    workOrderStatusName?: string;
    workOrderStatusColor?: string;
    isCompleted?: boolean;
}

/** "Warehouse, Room, Location", skipping any level the unit doesn't have. */
export function handlingUnitLocation(hum?: Pick<HandlingUnitMasterDTO, 'warehouseName' | 'roomName' | 'roomLocationName'>): string {
    return [hum?.warehouseName, hum?.roomName, hum?.roomLocationName].filter(Boolean).join(', ');
}
